// Excel (.xlsx) download with SheetJS, loaded from the CDN only when needed.
//   downloadExcel('report.xlsx', [{ name: 'Summary', rows: [['Label', 'Value'], ...] },
//                                 { name: 'Details', rows: [{ Col: 1, ... }, ...] }])
// `rows` is either an array of arrays (first row = header) or an array of objects.

let loading = null;
export function loadSheetJS() {
  if (window.XLSX) return Promise.resolve(window.XLSX);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = () => resolve(window.XLSX);
      s.onerror = () => { loading = null; reject(new Error('Could not load the Excel library — check the internet connection')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

export async function downloadExcel(filename, sheets) {
  const XLSX = await loadSheetJS();
  const wb = XLSX.utils.book_new();
  for (const sh of sheets) {
    const rows = sh.rows || [];
    const ws = rows.length && !Array.isArray(rows[0])
      ? XLSX.utils.json_to_sheet(rows)
      : XLSX.utils.aoa_to_sheet(rows.length ? rows : [['No data']]);
    // Column widths from the longest value (max 60 characters)
    const aoa = XLSX.utils.sheet_to_json(ws, { header: 1, defval: '' });
    ws['!cols'] = (aoa[0] || []).map((_, c) => ({
      wch: Math.min(60, Math.max(8, ...aoa.map(r => String(r[c] ?? '').length + 2))),
    }));
    XLSX.utils.book_append_sheet(wb, ws, String(sh.name || 'Sheet').slice(0, 31));
  }
  XLSX.writeFile(wb, filename);
}
